import { c as _c } from "react/compiler-runtime";
// Font Awesome Pro 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2024 Fonticons, Inc.
// svgs/regular/sunrise.svg: path and width byte-identical (components/icons, Phase 5).
export default function RegularSunriseIcon(t0) {
  const $ = _c(3);
  const {
    className
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <path d="M271 7c9.4-9.4 24.6-9.4 33.9 0l80 80c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-39-39L312 200c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-118.1-39 39c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L271 7zM393.3 225.8c7.5 3.1 12.9 9.8 14.4 17.8l18.1 98.5 98.5 18.1c8 1.5 14.7 6.9 17.8 14.4s2.2 16.1-2.4 22.8L493.9 464l58.1 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 512c-13.3 0-24-10.7-24-24s10.7-24 24-24l58.1 0L36.2 397.5c-4.6-6.7-5.5-15.3-2.4-22.8s9.8-13 17.8-14.4l98.5-18.1 18.1-98.5c1.5-8 6.9-14.7 14.4-17.8s16.1-2.2 22.8 2.4L288 285.1l82.5-56.9c6.7-4.6 15.3-5.5 22.8-2.4zM140.4 464l36.7 0c7.8-54.3 54.4-96 110.9-96s103.1 41.7 110.9 96l36.7 0 43.6-63.2-78.3-14.4c-9.8-1.8-17.5-9.5-19.3-19.3l-14.4-78.3L301.6 334c-8.2 5.7-19 5.7-27.2 0l-65.6-45.2-14.4 78.3c-1.8 9.8-9.5 17.5-19.3 19.3L96.8 400.8 140.4 464zM350 464c-7.1-27.6-32.2-48-62-48s-54.9 20.4-62 48l124 0z" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== className) {
    t2 = <svg aria-hidden="true" className={className} data-page-icon="regular/sunrise" fill="currentColor" focusable="false" height="1em" overflow="visible" viewBox="0 0 576 512" width="1.125em">{t1}</svg>;
    $[1] = className;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}